import { Button, Stack, Text } from "@mantine/core";
import { FaRocket } from "react-icons/fa";
import { useAppDispatch } from "../../../app/hooks";
import { thunkAutoPipeRouting } from "./autoPipeRoutingThunks";

export const AutoPipeRoutingStartStep = () => {
  const dispatch = useAppDispatch();

  return (
    <Stack gap="md" align="center" py="md">
      <Text size="sm" c="dimmed" ta="center">
        Alt er klart. Start automatisk rordragning for de valgte rommene.
      </Text>

      <Button
        size="lg"
        leftSection={<FaRocket size={16} />}
        onClick={() => dispatch(thunkAutoPipeRouting())}
      >
        Starta rordragning
      </Button>
    </Stack>
  );
};
